import {useLocation} from "react-router";
import {route_path} from "../routes/ThankYou_Route";

const useIsThankYouRoute = ()=>{
    const {pathname} = useLocation();

    return route_path===pathname;
}

export default useIsThankYouRoute;